var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"exact":"","to":{ name: _vm.menu.vue_name }}},[_c('v-list-item-icon',{staticClass:"mr-3"},[_c('v-icon',{attrs:{"size":"18"}},[_vm._v(" "+_vm._s(_vm.menu.icon)+" ")])],1),_c('v-list-item-title',{staticClass:"avatar-menu-text"},[_vm._v(" "+_vm._s(_vm.menu.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }